import { render, staticRenderFns } from "./WeddingInfo.vue?vue&type=template&id=28a88047&"
import script from "./WeddingInfo.vue?vue&type=script&lang=js&"
export * from "./WeddingInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports